var dd = require('ES/lib/dd');
var _ = require('ES/lib/lodash');
var radio = require('ES/lib/radio');
var ErrorAlert = require('ES/widgets/ErrorAlert');
var LoadingWrap = require('ES/widgets/LoadingWrap');
var ServicesUtils = require('ES/utils/ServicesUtils');

module.exports = dd.createClass({
    mixins: [ServicesUtils.RadioAjaxMixin("read_Thirdpartyconnection_APIkey_config", "save_Thirdpartyconnection_APIkey_config")],

    getInitialState: function () {
        return {
            sid: -1,
            save_error_msg: null,
            read_error_msg: null,
            saving: false
        };
    },
    componentWillReceiveProps: function (props) {
        this.__loadForSid(props.selected_sid);
    },
    componentDidMount: function () {
        this.__loadForSid(this.props.selected_sid);
    },
    componentWillMount: function () {
        var self = this;
        self.radio = {
            save_Thirdpartyconnection_APIkey_config_failed: function (sid, message) {
                if (self.state.sid == sid) {
                    self.setState({config: null, saving: false, save_error_msg: 'Problem changing your API key: ' + message});
                }
            },
            save_Thirdpartyconnection_APIkey_config_succeeded: function (sid, data) {
                if (self.state.sid == sid) {
                    self.setState({config: data, save_error_message: null});
                }
            }
        };
    },
    __loadForSid: function (sid) {
        if (sid !== this.state.sid) {
            this.setState({sid: sid}, function () {
                var self = this;
                radio('read_Thirdpartyconnection_APIkey_config').broadcast(sid,
                    function (sid, data) {
                        if (self.state.sid == sid) {
                            self.setState({config: data, read_error_msg: null});
                        }
                    },
                    function (sid, message) {
                        if (self.state.sid == sid) {
                            self.setState({read_error_msg: message});
                        }
                    });
            });
        }
    },
    __onSubmit: function () {
        radio('save_Thirdpartyconnection_APIkey_config').broadcast(this.state.sid,
            function (sid, data) {
                //see componentWillMount()
            }
        );
    },
    render: function () {
        let Displaylists = this.props.Displaylists;
        let speaker = _.find(_.get(Displaylists, "perspeaker"), {'sid': this.state.sid});
        let espeakers_apikey = _.get(this.state, "config.espeakers_apikey", null);

        return dd.div(null,
            LoadingWrap({
                    is_loading: this.state.saving,
                    glass: true
                },
                dd.h3(null,
                    'eSpeakers API key for ',
                    dd.span({className: 'nametag'},
                        speaker ? speaker.name_full : ''
                    )
                ),
                ErrorAlert({message: this.state.save_error_msg}),
                ErrorAlert({message: this.state.read_error_msg}),
                dd.p({className: 'text-muted'},
                    'This is the API key for ',
                    speaker ? speaker.name_full : '',
                    '. Use it to give third-party software access to your eSpeakers data.'
                ),
                dd.p({className: 'text-muted'},
                    'TREAT THIS LIKE A PASSWORD. Any service that knows this key can access and change your eSpeakers data.'
                ),
                (espeakers_apikey) ? dd.div({
                        className: 'well',
                        style: {fontSize: '0.85em', fontFamily: 'monospace', wordWrap: 'break-word', wordBreak: 'break-all', whiteSpace: 'normal'}
                    },
                    espeakers_apikey) : null,
                dd.div({className: 'pull-right'},
                    dd.div({},
                        'Change your API Key to invalidate any services using the current one and generate a new key.'),
                    dd.button({className: 'pull-right btn btn-sm', onClick: this.__onSubmit}, 'Change API Key')
                )
            )
        );
    }
});




//// NEWER STYLE (almost complete)

//
// import _ from "ES/lib/lodash";
// import React from "ES/lib/react";
// import radio from "ES/lib/react-pubsub-via-radio.js/radio";
// import ErrorAlert from "ES/widgets/ErrorAlert";
// import LoadingWrap from "ES/widgets/LoadingWrap";
// import CopyToClipboard from 'react-copy-to-clipboard';
// import ServicesUtils from 'ES/utils/ServicesUtils';
//
//
// //export default React.createClass({
// //export default React.createFactory(React.createClass({
// class APIkey extends React.Component {
//
//     //mixins: [ServicesUtils.RadioAjaxMixin("read_Thirdpartyconnection_APIkey_config", "save_Thirdpartyconnection_APIkey_config")],
//
//     getInitialState() {
//         return {
//             sid: -1,
//             save_error_msg: null,
//             read_error_msg: null,
//             saving: false,
//             copied: false
//         };
//     }
//
//     componentWillReceiveProps(props) {
//         this.__loadForSid(props.selected_sid);
//     }
//
//     componentDidMount() {
//         this.__loadForSid(this.props.selected_sid);
//     }
//
//     componentWillMount() {
//         var self = this;
//         self.radio = {
//             save_Thirdpartyconnection_APIkey_config_failed: function (sid, message) {
//                 if (self.state.sid == sid) {
//                     self.setState({config: null, saving: false, save_error_msg: 'Problem changing your API key: ' + message});
//                 }
//             },
//             save_Thirdpartyconnection_APIkey_config_succeeded: function (sid, data) {
//                 if (self.state.sid == sid) {
//                     self.setState({config: data, save_error_message: null});
//                 }
//             }
//         };
//     }
//
//     __loadForSid(sid) {
//         if (sid !== this.state.sid) {
//             this.setState({sid: sid}, function () {
//                 var self = this;
//                 radio('read_Thirdpartyconnection_APIkey_config').broadcast(sid,
//                     function (sid, data) {
//                         if (self.state.sid == sid) {
//                             self.setState({config: data, read_error_msg: null});
//                         }
//                     },
//                     function (sid, message) {
//                         if (self.state.sid == sid) {
//                             self.setState({read_error_msg: message});
//                         }
//                     });
//             });
//         }
//     }
//
//     __onSubmit() {
//         radio('save_Thirdpartyconnection_APIkey_config').broadcast(this.state.sid,
//             function (sid, data) {
//                 //see componentWillMount()
//             }
//         );
//     }
//
//     render() {
//         let Displaylists = this.props.Displaylists;
//         let speaker = _.find(_.get(Displaylists, "perspeaker"), {'sid': this.state.sid});
//         let espeakers_apikey = _.get(this.state, "config.espeakers_apikey", null);
//         //const {copied} = this.state;
//
//         return <div>
//             <LoadingWrap is_loading={this.state.saving} glass={true}>
//                 <h3>
//                     eSpeakers API key for <span className="nametag">{_.get(speaker, "name", "")}</span>
//                 </h3>
//                 <ErrorAlert message={this.state.save_error_msg}/>
//                 <ErrorAlert message={this.state.read_error_msg}/>
//                 <p className="text-muted">
//                     This is the API key for {_.get(speaker, "name", "")}. Use this to give third-party software access to your eSpeakers data.
//                 </p>
//                 {espeakers_apikey && <div className="well" style={{fontSize: "0.85em", fontFamily: "monospace", wordWrap: "break-word", wordBreak: "break-all", whiteSpace: "normal"}}>
//                     {espeakers_apikey}
//                     <CopyToClipboard text={espeakers_apikey} onCopy={() => this.setState({copied: true})}>
//                         <a style={{marginLeft: "0.5em"}}><span className="glyphicon glyphicon-paste"></span></a>
//                     </CopyToClipboard>
//                 </div>
//                 }
//                 <div className="pull-right">
//                     <div>Change your API Key to break the connection from any services using the current one, and generate a new key.</div>
//                     <button className="pull-right btn btn-sm" onClick={this.__onSubmit}>Change API Key</button>
//                 </div>
//             </LoadingWrap>
//         </div>;
//     }
// };



// WEBPACK FOOTER //
// ./src/components/account_settings/connect/APIkey.js